var neutral = {
  variant: 'neutral'
};
var alert = {
  variant: 'alert'
};
var accent = {
  variant: 'accent'
};
var notify = {
  variant: 'notify'
};
var tagInnerVariants = {
  neutral: neutral,
  alert: alert,
  accent: accent,
  notify: notify
};

export { tagInnerVariants };
//# sourceMappingURL=tag-inner.variants.esm.js.map
